<!-- =========================================================================================
  File Name: BookAddTabInformation.vue
  Description: Book Add Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>

    <!-- Content Row -->
    <div class="vx-row"> 
      <div class="vx-col md:w-1/2 w-full">
        <vs-input class="w-full mt-4" label="교재명" v-model="bookName" v-validate="'required'" name="bookName"
        placeholder="" />
        <span class="text-danger text-sm" v-show="errors.has('bookName')">{{ errors.first('bookName') }}</span>

        <vs-input class="w-full mt-4" label="판매가" v-model="price" v-validate="'required'" name="price" 
        placeholder=""/>
        <span class="text-danger text-sm" v-show="errors.has('price')">{{ errors.first('price') }}</span>

        <vs-input class="w-full mt-4" label="비고" v-model="remark" v-validate="'required'" name="remark" 
        placeholder=""/>
        <span class="text-danger text-sm" v-show="errors.has('remark')">{{ errors.first('remark') }}</span>

      </div>
    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="confirmSave" :disabled="!validateForm">저장</vs-button>
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="$router.go(-1)">취소</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'

import { postData } from '@/api/module'

export default {
  components: {
    vSelect
  },
  data () {
    return {
      bookName: '',
      price: '',
      remark: ''
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any()
    }
  },
  methods: {
    confirmSave () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: '교재 추가',
        text: '저장 하시겠습니까?',
        accept: this.save,
        acceptText: '저장'
      })
    },
    async save () {
      if (!this.validateForm) return

      try {
        const { data } = await postData('book', {
            
          bookName : this.bookName,
          price : this.price,
          remark : this.remark 
        })
        this.$router.push('/book/book-list')
        this.showSaveSuccess()

      } catch (error) {
        // console.log(error.response.data.msg);
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    },
    showSaveSuccess () {
      this.$vs.notify({
        color: 'success',
        title: '교재 추가',
        text: '저장 되었습니다.'
      })
    }
  }
}
</script>
